import React, { useEffect, useState } from "react";
import {
  createPartDamageAssigned,
  deletePartDamageAssigned,
  getpartDamageList,
  getPartVideoSortDetails,
  PartInventoryImageDetails,
} from "../../services/PartsInventory";
import {
  Button,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";
import ConfigDB from "../../config";
import { useTranslation } from "react-i18next";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const AssignedDamageVideo = ({
  partVideoDataList,
  setCurrentStep,
  setCurrentPartVideoIndex,
  partsData,
  currentPartVideoIndex,
}) => {
  const tableLengthList = ConfigDB?.data?.dataTableLength;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { uuid } = useParams();

  const [vehicleVideoDetails, setVehicleVideoDetails] = useState([]);
  const [damageList, setDamageList] = useState([]);
  const [selectedDamages, setSelectedDamages] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [existingDamages, setExistingDamages] = useState({});

  const handleChange = (selectedOptions, imgVideoId) => {
    const formattedDamages = selectedOptions.map((option) => ({
      damage_id: option.value,
    }));

    setSelectedDamages((prevState) => ({
      ...prevState,
      [imgVideoId]: formattedDamages,
    }));
  };

  const onDeleteModalOpen = (e, item) => {
    const data = item?.find((item) => item.id)?.id;
    e.preventDefault();
    setDelPart(data);
    setDelModal(true);
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart };
    deletePartDamageAssigned(data)
      .then((response) => {
        toast.success(response.data.message);

        var obj = {
          id: uuid,
        };
        PartInventoryImageDetails(obj)
          .then((response) => {
            response = response.data.data;
            setVehicleVideoDetails(response);
          })
          .catch((err) => {});

        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(() => {
    if (
      vehicleVideoDetails &&
      vehicleVideoDetails.some(
        (item) => item.damage_list && item.damage_list.length > 0
      )
    ) {
      const formattedDamages = {};

      vehicleVideoDetails.forEach((item) => {
        if (item.damage_list && item.damage_list.length > 0) {
          formattedDamages[item.id] = item.damage_list.map((d) => ({
            damage_id: Number(d.damage_id),
          }));
        }
      });

      setExistingDamages(formattedDamages);
      setSelectedDamages(formattedDamages);
    }
  }, [vehicleVideoDetails]);

  useEffect(function () {
    const data = partVideoDataList?.find(
      (item) => item.vehicle_part_id
    )?.vehicle_part_id;
    var obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
      part_id: uuid ? uuid : data,
    };
    getpartDamageList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].damage_description,
          });
        }
        setDamageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(
    function () {
      const data = partVideoDataList?.find(
        (item) => item.vehicle_part_id
      )?.vehicle_part_id;
      if (data || uuid) {
        var obj = {
          id: uuid ? uuid : data,
        };
        getPartVideoSortDetails(obj)
          .then((response) => {
            response = response.data.data;
            setVehicleVideoDetails(response);
          })
          .catch((err) => {});
      }
    },

    [uuid]
  );

  const handleFinish = (event) => {
    event.preventDefault();
    const dataPart = partVideoDataList?.find(
      (item) => item.vehicle_part_id
    )?.vehicle_part_id;

    const damageList = Object.entries(selectedDamages).map(
      ([imgVideoId, damages]) => ({
        img_video_id: parseInt(imgVideoId),
        damages,
      })
    );
    /* comment for 6 aug */

    const isEdit = !!uuid;

    const hasNewDamages =
      JSON.stringify(selectedDamages) !== JSON.stringify(existingDamages);

    // if (isEdit && !hasNewDamages) {
    //   toast.error("No new damages added.");
    //   return;
    // }

    let data = {
      img_video_type: 2, //1= image ,2= video
      vehicle_part_id: uuid ? uuid : dataPart,
      damage_list: damageList,
    };

    createPartDamageAssigned(data)
      .then((response) => {
        toast.success(response.data.message);

        const uploadedPartIds = partVideoDataList.map((item) =>
          String(item.vehicle_part_id)
        );

        const nextIndex = partsData.findIndex((part, idx) => {
          const isAfterCurrent = idx > currentPartVideoIndex;

          const isNotUploaded = !uploadedPartIds.includes(String(part.id));

          return isAfterCurrent && isNotUploaded;
        });

        if (nextIndex !== -1) {
          setCurrentPartVideoIndex(nextIndex);
          setCurrentStep(5);
        } else {
          navigate("/parts-inventory");
        }
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleBackButtonClick = () => {
    setCurrentStep(2);
  };

  const handleNextButtonClick = () => {
    if (uuid) {
      navigate("/parts-inventory");
      return;
    }

    const uploadedPartIds = partVideoDataList.map((item) =>
      String(item.vehicle_part_id)
    );
    const currentPart = partsData[currentPartVideoIndex];

    const isUploaded = uploadedPartIds.includes(String(currentPart?.id));
    const hasDamage = currentPart?.parts_damage?.length > 0;

    const isDamageAssigned = partVideoDataList.some((item) => {
      return (
        String(item.vehicle_part_id) === String(currentPart?.id) &&
        Array.isArray(item.assigned_damages) &&
        item.assigned_damages.length > 0
      );
    });

    if (isUploaded && hasDamage && !isDamageAssigned) {
      const nextIndex = partsData.findIndex((part, idx) => {
        const isAfterCurrent = idx > currentPartVideoIndex;
        const notUploaded = !uploadedPartIds.includes(String(part.id));
        return isAfterCurrent && notUploaded;
      });

      if (nextIndex !== -1) {
        setCurrentPartVideoIndex(nextIndex);
        setCurrentStep(3);
      } else {
        setCurrentStep(5);
      }

      return;
    }

    if (isUploaded && hasDamage && isDamageAssigned) {
      setCurrentStep(4);
      return;
    }

    const nextIndex = partsData.findIndex((part, idx) => {
      const isAfterCurrent = idx > currentPartVideoIndex;
      const notUploaded = !uploadedPartIds.includes(String(part.id));
      return isAfterCurrent && notUploaded;
    });

    if (nextIndex !== -1) {
      setCurrentPartVideoIndex(nextIndex);
      setCurrentStep(3);
    } else {
      setCurrentStep(5);
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-12">
            <FormGroup>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>{t("image")}</th>
                    <th>{t("pi_assign_damage")}</th>
                    <th>{t("action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {vehicleVideoDetails && vehicleVideoDetails.length > 0 ? (
                    vehicleVideoDetails.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <video
                            src={item.video_url}
                            width="100"
                            controls
                            style={{
                              borderRadius: "5px",
                              margin: "5px",
                            }}
                          >
                            Your browser does not support the video tag.
                          </video>
                        </td>
                        <td>
                          <Select
                            className="my-Select"
                            options={damageList}
                            value={selectedDamages[item.id]?.map((d) =>
                              damageList.find(
                                (opt) => opt.value === d.damage_id
                              )
                            )}
                            onChange={(selected) =>
                              handleChange(selected, item.id)
                            }
                            placeholder={t("pi_select_damage")}
                            isSearchable
                            isMulti
                            isClearable
                          />
                        </td>
                        {item?.damage_list?.length > 0 && (
                          <td>
                            <div
                              className="trash-btn"
                              onClick={(e) =>
                                onDeleteModalOpen(e, item.damage_list)
                              }
                            >
                              <a className="delete-btn" href="#">
                                <i className="bi bi-trash3"></i>
                              </a>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        {t("pi_no_data_found")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="back-footer">
                <div className="back-next back-next-custom">
                  <div className="row">
                    <div className="col">
                      <button
                        type="button"
                        className="next-button btn btn-secondary ms-0"
                        onClick={handleBackButtonClick}
                      >
                        <i className="bi bi-arrow-left"></i> {t("back")}
                      </button>
                    </div>
                    <div
                      className="col nxt-btn mr-0"
                      style={{ marginLeft: "848px" }}
                    >
                      <Button
                        className="next-button"
                        type="button"
                        onClick={handleFinish}
                      >
                        {t("save")} <i className="bi bi-arrow-right"></i>
                      </Button>
                    </div>

                    <div className="col nxt-btn mr-0">
                      <Button
                        className="next-button"
                        type="button"
                        onClick={handleNextButtonClick}
                      >
                        {t("finish")} <i className="bi bi-arrow-right"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </FormGroup>
          </div>
        </div>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("pi_delete_damage")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{t("pi_delete_damage_confirm")}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyPartType}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AssignedDamageVideo;
